import { CommonGridToolBarWithFilterText } from '../../../Components/Common Components/CommonComponents';
import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Checkbox, IconButton, TextField, CircularProgress, Box, Typography, Tooltip, FormControl, RadioGroup, Radio, FormControlLabel, Drawer, Stack, Button, Autocomplete } from "@mui/material";
import { Colors } from "../../../Styles/Colors";
import { ImagePaths } from "../../../Utility/ImagePaths";
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import { AmountsCard } from '../../../Components/CommonCards/CommonCards';
import CommonDatePicker from '../../../Components/Common Components/CommonDatePicker';
import { DateTime } from 'luxon';
import { useHistory } from 'react-router-dom';

const datelist = {
  fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
  toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
  dateIndex: 1,
  selectVendor: null,
}

const StoreVendorPerformance = () => {
  const history = useHistory()
  const [page, setpage] = useState(0);
  const [pageSize, setpageSize] = useState(10);
  const [stockValue, setstockValue] = useState([]);
  const [isloader, setisloader] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [errorMsg, seterrorMsg] = useState(false);
  const [errorMsgText, seterrorMsgText] = useState('');
  const [successMsg, setsuccessMsg] = useState(false);
  const [successMsgText, setsuccessMsgText] = useState('');
  const [filterData, setfilterData] = useState(datelist);
  const [vendorList, setVendorList] = useState([]);
  const [totalValue, setTotalValue] = useState(0);
  const [totalGrn, settotalGrn] = useState(0);

  useEffect(() => {
    getStoreStockValue()
    getVendorList()
  }, [])

  const errorMessage = (msg) => {
    seterrorMsgText(msg)
    seterrorMsg(true)
  }
  const successMessage = (msg) => {
    setsuccessMsgText(msg)
    setsuccessMsg(true)
  }

  const getVendorList = (VendorId = null) => {
    try {
      RestAPIService.getAll(Serviceurls.STORE_VENDOR)
        .then((response) => {
          if (response.data.status === 'success') {
            setVendorList(response.data.data || [])
          }
        }).catch(e => {
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      errorMessage(e.message)
    }
  }

  const generateUrl = (addQuery = "") => {
    let url = `${Serviceurls.STORE_VENDOR_PERFORMANCE_REPORT}?from_date=${filterData?.fromDate || ""}&to_date=${filterData?.toDate || ""}&vendor_id=${filterData?.selectVendor?.id || ""}`;
    if (addQuery) {
      url += addQuery
    }
    return url
  }

  const getStoreStockValue = () => {
    try {
      setisloader(true)
      const url = generateUrl();
      RestAPIService.getAll(url)
        .then((response) => {
          if (response.data.status === 'success') {
            setstockValue(response.data.data || [])
            setTotalValue(response.data.total_purchase_value || 0)
            settotalGrn(response.data.total_grn || 0)
            setisloader(false)
          }
        }).catch(e => {
          setisloader(false)
          if (e?.response?.data?.message) {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      setisloader(false)
      errorMessage(e.message)
    }
  }

  const getVendorPerformPrint = () => {
    const url = generateUrl("&export_type=pdf");
    try {
      RestAPIService.getAllPrint(url)
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }).catch((error) => {
          errorMessage(error?.response?.data?.message || error?.message)
        })
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const FilterDate = (from, to, index) => {
    setfilterData({ ...filterData, fromDate: from, toDate: to, dateIndex: index })
  }

  const renderFilterScreen = () => {
    return (
      <Box className='eMed_rts_filter_container' >
        <Box className='eMed_filter_Top'>
          <Typography variant='h6' fontWeight={600}>Filter</Typography>
          <Tooltip>
            <Button onClick={() => { setFilterOpen(false) }}>
              <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_Canteen_CloseImg' />
            </Button>
          </Tooltip>
        </Box>
        <Box className='eMed_rts_middle'>
          <Box className='eMed_date_filter'>
            <CommonDatePicker
              FromDate={filterData.fromDate}
              ToDate={filterData.toDate}
              DateIndex={filterData.dateIndex}
              SelectedDates={FilterDate.bind(this)}
              HideAllMenu={true} />
          </Box>
          <Box className='eMed_rts_dropdown'>
            <Autocomplete
              size='small'

              value={filterData.selectFromloc}
              options={vendorList}
              getOptionLabel={(option) => (typeof (option) === 'string') ? option : option?.vendor_name}
              onChange={(event, newValue) => {
                setfilterData({ ...filterData, selectVendor: newValue })
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={'Select Vendor'}
                />
              )} />
          </Box>
        </Box>
        <Box>
          <Stack spacing={2} direction="row" justifyContent={'center'}>
            <Button size='small' variant='outlined' className='eMed_Canteen_BtnText' onClick={() => { setfilterData(datelist) }}>Clear</Button>
            <Button size='small' variant='contained' className='eMed_Canteen_BtnText' onClick={() => {
              getStoreStockValue()
              setFilterOpen(false)
            }}>Search</Button>
          </Stack>
        </Box>
      </Box>
    )
  }


  const closeFilter = () => {
    setFilterOpen(false);
  }

  const tableView = () => {
    try {
      const gridToolBar = () => {
        return (
          <Box>
            <CommonGridToolBarWithFilterText />
          </Box>
        )
      }
      stockValue?.forEach((element, index) => element.sno = index + 1)
      const columns = [
        {
          field: 'vendor_name', headerName: 'Vendor Name', flex: 0.07,
          renderCell: (params) => (<Box component={'div'}>{params?.row?.vendor_name || '-'}</Box>)
        },
        {
          field: 'average_period', headerName: 'Average Period', flex: 0.07,
          renderCell: (params) => (<Box component={'div'}>{params?.row?.average_period || 0}</Box>)
        },
        {
          field: 'no_of_grn', headerName: 'No of GRN', flex: 0.07,
          renderCell: (params) => (<Box component={'div'}>{params?.row?.no_of_grn || 0}</Box>)
        },
        {
          field: 'free_quantity', headerName: 'Free Qty', flex: 0.07,
          renderCell: (params) => (<Box component={'div'}>{params?.row?.free_quantity || 0}</Box>)
        },
        {
          field: 'purchase_price', headerName: 'Purchase Price', flex: 0.07,
          renderCell: (params) => (<Box component={'div'}>{params?.row?.purchase_price || 0}</Box>)
        },
        {
          field: 'credit_note', headerName: 'Credit Note', flex: 0.07,
          renderCell: (params) => (<Box component={'div'}>{params?.row?.credit_note || 0}</Box>)
        },
      ];
      return (
        <Box sx={{ height: '67vh', marginTop: '.5vw', backgroundColor: 'white' }}>
          <DataGrid
            rows={stockValue}
            columns={columns}
            getRowId={(row) => row['sno']}
            page={page}
            pageSize={pageSize}
            localeText={{
              toolbarColumns: "",
              toolbarDensity: "",
              toolbarExport: "",
              toolbarFilters: "",
              toolbarExportPrint: ""
            }}
            components={{
              Toolbar: gridToolBar,
              NoRowsOverlay: () => (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                  {'No Records To Be Shown'}
                </Box>
              )
            }}
            onPageChange={(newPage) => { setpage(newPage) }}
            onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
            rowsPerPageOptions={[10, 20, 30]}
            pagination
            headerHeight={40}
            density='standard'
            disableSelectionOnClick
            loading={isloader}
          />
        </Box>
      )
    } catch (e) {

    }
  }

  const msgClose = () => {
    seterrorMsg(false)
    seterrorMsgText("")
    setsuccessMsg(false)
    setsuccessMsgText("")
  }

  return (
    <Box sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
      <Box display={'flex'} justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
        <Box display={'flex'} flexDirection={'row'} marginLeft={'-.8vw'}>
          {AmountsCard('Total GRN', totalGrn, true)}
          {AmountsCard('Total Purchase Value', totalValue)}
        </Box>
        <Box>
          <IconButton onClick={() => { setFilterOpen(true) }}>
            <img style={{ width: '2vw', height: '2vw' }} src={ImagePaths.Filter.default} alt='filter' />
          </IconButton>
          {/* <IconButton onClick={() => { history.push('/StoreReports/VendorPerformanceChart') }}>
            <img style={{ width: '2vw', height: '2vw' }} src={ImagePaths.ChartIcons.default} alt='filter' />
          </IconButton> */}
          <IconButton onClick={getVendorPerformPrint}>
            <img style={{ width: '2vw', height: '2vw' }} src={ImagePaths.LabPrintIcon.default} alt='filter' />
          </IconButton>
          {/* <IconButton>
            <img style={{ width: '2vw', height: '2vw' }} src={ImagePaths.ExportIcon.default} alt='filter' />
          </IconButton> */}
        </Box>
      </Box>
      <Box>
        {tableView()}
      </Box>
      <Drawer
        anchor={'right'}
        open={filterOpen}
        ModalProps={{ onBackdropClick: closeFilter }}
      >
        {renderFilterScreen()}
      </Drawer>
      {errorMsg ?
        <ToastMsg
          severity={'error'}
          msg={errorMsgText}
          msgPop={msgClose.bind(this)}
        />
        : null}
      {successMsg ?
        <ToastMsg
          severity={'success'}
          msg={successMsgText}
          msgPop={msgClose.bind(this)}
        />
        : null}
    </Box>
  );
}

export default StoreVendorPerformance